import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import Sidebar from "../../Components/Sidebar";
import Backdrop from "@mui/material/Backdrop";
import {
  Box,
  Button,
  Fade,
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Slider,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import ErrorBox from "../../Components/ErrorBox";
import Avatar from "react-avatar-edit";
import { useDropzone } from "react-dropzone";
import { useMemo } from "react";
import { useGlobal } from "../../Helper/Context/GlobalContext";
import { LoadingButton } from "@mui/lab";
import { LocationCity } from "@mui/icons-material";
import jwt from "jwt-decode";
import TemplateModal from "../../Components/Template/TemplateModal";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../Components/cropImage";
import { baseStyle } from "../../Helper/style/style";
import { base64ToFile } from "../../Helper/image/imageFunction";
import ResumeTemplateModal from "../../Components/ResumeTemplate/ResumeTemplateModal";

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

function FormTambahRD() {
  //==================================================Context
  const masukContext = useGlobal();
  const {
    loginToken,
    dataKonfirm,
    setDataKonfirm,
    setToOpenKonfirm,
    openErrorBox,
    setErrorServer,
  } = masukContext;
  //=========================================================authorize

  const history = useHistory();
  const auth = () => {
    let token = { role: "" };
    if (loginToken) {
      token = jwt(loginToken);
    }
    if (token.role != "super") {
      history.push("/");
    }
  };

  //==============================================Agent
  const [agent, setAgent] = useState(false);
  const handleChange = (event) => {
    setAgent(event.target.checked);
  };
  //============================================================== Loading Button
  const [loadingSts, setLoadingSts] = useState(false);
  function handleLoading() {
    setLoadingSts(true);
  }
  function handleCloseLoading() {
    setLoadingSts(false);
  }

  //========================================show rd
  const handleChangeShow = (event) => {
    setData({ ...data, show_rd_generate: event.target.checked });
  };
  //========================================handling input
  const initialState = {
    logo: "",
    nama_rd: "",
    alamat: "",
    tlp: "",
    fk_id_prov: "",
    fk_id_kota: "",
    harga: "",
    commission: "",
    fk_id_template: "",
    saldo: "",
    discount: "",
    show_rd_generate: false,
  };
  const [data, setData] = useState(initialState);
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setData({
      ...data,
      [name]: value,
    });

    if (name === "fk_id_prov") {
      GetKota(value);
    }
  };
  //========================================logo input
  const [logo, setLogo] = useState("");
  const cropAvatar = (view) => {
    setLogo(view);
  };

  //========================================Dropzone Default
  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
    isDragActive,
    acceptedFiles,
  } = useDropzone({ accept: { "image/*": [] } });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );
  useEffect(() => {
    if (acceptedFiles.length !== 0) {
      handleImageDrop("default", acceptedFiles[0]);
    }
  }, [acceptedFiles]);
  //========================================Dropzone Akhir
  const {
    getRootProps: getRootPropsEnd,
    getInputProps: getInputPropsEnd,
    isFocused: isFocusedEnd,
    isDragAccept: isDragAcceptEnd,
    isDragReject: isDragRejectEnd,
    isDragActive: isDragActiveEnd,
    acceptedFiles: acceptedFilesEnd,
  } = useDropzone({ accept: { "image/*": [] } });

  const styleend = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocusedEnd ? focusedStyle : {}),
      ...(isDragAcceptEnd ? acceptStyle : {}),
      ...(isDragRejectEnd ? rejectStyle : {}),
    }),
    [isFocusedEnd, isDragAcceptEnd, isDragRejectEnd]
  );
  useEffect(() => {
    if (acceptedFilesEnd.length !== 0) {
      handleImageDrop("end", acceptedFilesEnd[0]);
    }
  }, [acceptedFilesEnd]);
  //=============================================templates
  const [modal, setModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(false);
  const closeModal = () => {
    setModal(false);
    const path = sessionStorage.getItem("selected_template");
    if (path) {
      setSelectedTemplate(
        dataTemplate.filter((item) =>
          item.path_image_template.includes(path)
        )[0]
      );
    }
  };
  const openModal = () => {
    setModal(true);
    sessionStorage.removeItem("selected_template");
  };
  const [dataTemplate, setDataTemplate] = useState([]);

  const getDaftarTemplate = async (/*userID*/) => {
    const url = process.env.REACT_APP_BASE_URL + "api/template/template";
    try {
      const response = await axios.get(url);
      setDataTemplate(
        response.data.map((e) => {
          return {
            nama_template: e.nama_template,
            pk_id_template: e.pk_id_template,
            deskripsi: e.deskripsi,
            path_thumb_template: e.path_thumb_template,
            path_image_template: e.path_image_template,
            bahasa: e.bahasa,
            religi: e.religi,
          };
        })
      );
    } catch (error) {
      if (error.response.data.length < 100) {
        setErrorServer(error.response.data);
      } else {
        setErrorServer(
          "Terjadi error saat mengambil data template, Mohon coba lagi"
        );
      }
      openErrorBox();
    }
  };
  //=============================================resume-templates

  const [swResume, setSwResume] = useState(true);
  const handleChangeResume = (event) => {
    setSwResume(event.target.checked);
  };

  const [modalResume, setModalResume] = useState(false);
  const [selectedTemplateResume, setSelectedTemplateResume] = useState(false);
  const closeModalResume = (id) => {
    setModalResume(false);
    setData({
      ...data,
      fk_id_resume_template: id,
    });
    if (id) {
      setSelectedTemplateResume(
        dataTemplateResume.filter((item) => item.pk_id_resume_template == id)[0]
      );
    }
  };
  const openModalResume = () => {
    setModalResume(true);
  };
  const [dataTemplateResume, setDataTemplateResume] = useState([]);

  const getDaftarTemplateResume = async (/*userID*/) => {
    const url =
      process.env.REACT_APP_BASE_URL + "api/ResumeTemplate/resume-template/0";
    try {
      const response = await axios.get(url);
      setDataTemplateResume(
        response.data.map((e) => {
          return {
            nama_resume_template: e.nama_resume_template,
            pk_id_resume_template: e.pk_id_resume_template,
            path_thumb_resume_template: e.path_thumb_resume_template,
            path_resume_template: e.path_resume_template,
            path_resume_template_tv: e.path_resume_template_tv,
          };
        })
      );
    } catch (error) {
      if (error.response.data.length < 100) {
        setErrorServer(error.response.data);
      } else {
        setErrorServer(
          "Terjadi error saat mengambil data resume template, Mohon coba lagi"
        );
      }
      openErrorBox();
    }
  };
  //========================================get prov & Kota

  const [dataProv, setDataProv] = useState([]);

  const GetProv = async () => {
    const url = process.env.REACT_APP_BASE_URL + "api/Provinsi/Provinsi";
    try {
      const response = await axios.get(url);
      setDataProv(response.data);
    } catch (error) {
      if (error.response.data.length < 100) {
        setErrorServer(error.response.data);
      } else {
        setErrorServer(
          "Terjadi error saat mengambil data provinsi, Mohon coba lagi"
        );
      }
      openErrorBox();
    }
  };

  const [dataKota, setDataKota] = useState([]);

  const GetKota = async (value) => {
    const url =
      process.env.REACT_APP_BASE_URL + "api/Kota/KotaByProv?id=" + value;

    try {
      const response = await axios.get(url);
      setDataKota(response.data);
    } catch (error) {
      if (error.response.data.length < 100) {
        setErrorServer(error.response.data);
      } else {
        setErrorServer(
          "Terjadi error saat mengambil data kota, Mohon coba lagi"
        );
      }
      openErrorBox();
    }
  };

  useEffect(() => {
    GetProv();
    getDaftarTemplate();
    getDaftarTemplateResume();
    auth();
  }, []);

  //================================================================================ modal crop
  const [openCrop, setOpenCrop] = React.useState(false);
  const handleOpen = () => setOpenCrop(true);
  const handleClose = () => setOpenCrop(false);

  //================================================================================= cropping
  const [image, setImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState(null);
  const [croppedImageEnd, setCroppedImageEnd] = useState(null);
  const [name, setName] = useState("default");
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleImageDrop = (name, acceptedFiles) => {
    const selectedImage = URL.createObjectURL(acceptedFiles);
    setImage(selectedImage);
    handleOpen();
    setName(name);
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(image, croppedAreaPixels, 0);
      if (name === "default") {
        setCroppedImage(croppedImage);
      } else {
        setCroppedImageEnd(croppedImage);
      }
    } catch (e) {}
  }, [croppedAreaPixels, 0]);

  const onCropChange = (crop) => {
    setCrop(crop);
  };

  const onZoomChange = (zoom) => {
    setZoom(zoom);
  };

  const CROP_AREA_ASPECT = 16 / 9;
  //==============================================================validation

  const [errors, setErrors] = useState(initialState);

  const checkValidate = () => {
    const validationErrors = {};
    if (!logo) {
      validationErrors.logo = "Masukan Logo Rumah Duka";
    }
    if (!data.nama_rd) {
      validationErrors.nama_rd = "Masukan Nama Rumah Duka";
    }
    if (!data.alamat) {
      validationErrors.alamat = "Masukan Alamat";
    }
    if (!data.tlp) {
      validationErrors.tlp = "Masukan Nomor Telepon";
    } else {
      const valid = /^[0-9]{1,13}$/.test(data.tlp);
      !valid && (validationErrors.tlp = "Telepon Tidak Valid");
    }
    if (!data.fk_id_prov) {
      validationErrors.fk_id_prov = "Masukan Provinsi";
    }
    if (!data.fk_id_kota) {
      validationErrors.fk_id_kota = "Masukan Kota";
    }
    if (!data.harga) {
      validationErrors.harga = "Masukan Harga Ucapan";
    } else {
      const valid = data.harga > 0;
      !valid && (validationErrors.harga = "Harga tidak boleh minus");
    }
    if (!data.commission) {
      validationErrors.commission = "Masukan Komisi";
    } else {
      const valid = data.commission > 0;
      !valid && (validationErrors.commission = "Komisi tidak boleh minus");
    }
    if (!selectedTemplate.pk_id_template) {
      validationErrors.fk_id_template = "Pilih template pesan";
    }
    if (agent) {
      if (!data.saldo) {
        validationErrors.saldo = "Masukan saldo";
      } else {
        const valid = data.saldo > 0;
        !valid && (validationErrors.saldo = "saldo tidak boleh minus");
      }
      if (!data.discount) {
        validationErrors.discount = "Masukan discount";
      } else {
        const valid = data.discount > 0;
        !valid && (validationErrors.discount = "Diskon tidak boleh minus");
      }
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      handleCloseLoading();
    } else {
      setToOpenKonfirm();
    }
  };
  //========================================handling submit
  useEffect(() => {
    if (dataKonfirm === true) {
      handleSubmit();
    } else if (dataKonfirm === false) {
      handleCloseLoading();
    }
    setDataKonfirm(null);
  }, [dataKonfirm]);

  const handleSubmit = async () => {
    const avatar = base64ToFile(logo);
    const response = await fetch(croppedImage);
    const blob = await response.blob();
    const responseEnd = await fetch(croppedImageEnd);
    const blobEnd = await responseEnd.blob();

    const formData = new FormData();
    if (croppedImage) {
      formData.append("default_image", blob, `${data.nama_rd.trim()}.jpg`);
    }
    if (croppedImageEnd) {
      formData.append("end_image", blobEnd, `${data.nama_rd.trim()}end.jpg`);
    }
    formData.append("avatar", avatar, `${data.nama_rd.trim()}.jpg`);
    formData.append("nama_rd", data.nama_rd.trim());
    formData.append("alamat", data.alamat);
    formData.append("tlp", data.tlp);
    formData.append("fk_id_prov", data.fk_id_prov);
    formData.append("fk_id_kota", data.fk_id_kota);
    formData.append("harga", data.harga);
    formData.append("commission", data.commission);
    formData.append("fk_id_template", selectedTemplate.pk_id_template);
    formData.append(
      "fk_id_resume_template",
      selectedTemplateResume.pk_id_resume_template
    );
    formData.append("show_resume_tv", swResume);
    formData.append("universal_template", true);
    formData.append("show_rd_generate", data.show_rd_generate);
    if (agent) {
      formData.append("agent.saldo", data.saldo);
      formData.append("agent.discount", data.discount);
    }
    if (data.pesan) {
      formData.append("pesan", data.pesan);
    }
    if (data.keterangan_pengirim) {
      formData.append("keterangan_pengirim", data.keterangan_pengirim);
    }

    const url = process.env.REACT_APP_BASE_URL + "api/RumahDuka/RumahDuka";
    await axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `bearer ${loginToken}`,
        },
      })
      .then(() => {
        history.push("/tambah_rd");
      })
      .catch((error) => {
        if (error.response.data.length < 100) {
          setErrorServer(error.response.data);
        } else {
          setErrorServer(
            "Terjadi error saat tambah rumah duka, Mohon coba lagi"
          );
        }
        openErrorBox();
      })
      .finally(() => {
        handleCloseLoading();
      });
  };

  return (
    <Layout>
      <Sidebar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          alignItems: "center",
          minHeight: 320,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "80%",
            alignItems: "center",
          }}
        >
          <Typography variant="h4" textAlign="center" my={4}>
            Form Tambah Rumah Duka
          </Typography>

          <ErrorBox />

          <Avatar width={150} height={150} onCrop={cropAvatar} />
          <Typography>Logo Rumah Duka</Typography>
          <FormHelperText error>{errors.logo}</FormHelperText>
          <TextField
            fullWidth
            required
            size="small"
            id="nama_rd"
            name="nama_rd"
            onChange={handleInputChange}
            label="Masukan nama rumah duka"
            variant="outlined"
            sx={{ mt: 3 }}
            error={!!errors.nama_rd}
            helperText={errors.nama_rd}
          />
          <TextField
            fullWidth
            required
            size="small"
            id="alamat"
            name="alamat"
            onChange={handleInputChange}
            label="Masukan alamat rumah duka"
            variant="outlined"
            sx={{ mt: 3 }}
            error={!!errors.alamat}
            helperText={errors.alamat}
          />

          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                size="small"
                id="provinsi"
                name="fk_id_prov"
                onChange={handleInputChange}
                label="Pilih Provinsi"
                variant="outlined"
                select
                defaultValue="0"
                error={!!errors.fk_id_prov}
                helperText={errors.fk_id_prov}
              >
                <MenuItem value="0">Pilih Provinsi...</MenuItem>
                {dataProv.map((option) => (
                  <MenuItem key={option.pk_id_prov} value={option.pk_id_prov}>
                    {option.nama_prov}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                size="small"
                id="kota"
                name="fk_id_kota"
                onChange={handleInputChange}
                label="Pilih Kota"
                variant="outlined"
                select
                defaultValue="0"
                error={!!errors.fk_id_kota}
                helperText={errors.fk_id_kota}
              >
                <MenuItem value="0">Pilih Kota...</MenuItem>
                {dataKota.map((option) => (
                  <MenuItem key={option.pk_id_kota} value={option.pk_id_kota}>
                    {option.nama_kota}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          <TextField
            fullWidth
            required
            size="small"
            id="tlp"
            name="tlp"
            onChange={handleInputChange}
            label="Masukan telepon rumah duka"
            variant="outlined"
            sx={{ mt: 3 }}
            error={!!errors.tlp}
            helperText={errors.tlp}
          />
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                required
                size="small"
                id="harga"
                name="harga"
                onChange={handleInputChange}
                label="Masukan harga ucapan"
                variant="outlined"
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                error={!!errors.harga}
                helperText={errors.harga}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                required
                size="small"
                id="commission"
                name="commission"
                onChange={handleInputChange}
                label="Masukan komisi Rumah Duka"
                variant="outlined"
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                error={!!errors.commission}
                helperText={errors.commission}
              />
            </Grid>
          </Grid>
          <Typography mt={8} mb={2}>
            Template Default
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                size="small"
                id="keterangan_pengirim"
                name="keterangan_pengirim"
                onChange={handleInputChange}
                label="Masukan keterangan pengirim pesan"
                variant="outlined"
                error={!!errors.keterangan_pengirim}
                helperText={errors.keterangan_pengirim}
                inputProps={{
                  maxLength: 30, // Set the maximum character limit
                }}
              />

              <TextField
                fullWidth
                required
                multiline
                size="small"
                id="pesan"
                name="pesan"
                onChange={handleInputChange}
                label="Masukan pesan"
                variant="outlined"
                sx={{ mt: 3 }}
                error={!!errors.pesan}
                helperText={errors.pesan}
                inputProps={{
                  maxLength: 100, // Set the maximum character limit
                }}
              />
              <Box sx={{ display: "flex", alignItems: "center", my: 1 }}>
                <Typography>
                  Gunakan tambahan kata "Rumah Duka" untuk generate pesan
                </Typography>
                <Switch
                  checked={data.show_rd_generate}
                  onChange={handleChangeShow}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              {selectedTemplate ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      selectedTemplate.path_thumb_template
                    }
                    alt={selectedTemplate.nama_template}
                    style={{ width: "300px" }}
                  />
                  <Typography>{selectedTemplate.nama_template}</Typography>
                  <Button
                    onClick={() => {
                      setSelectedTemplate(null);
                    }}
                    variant="contained"
                    size="small"
                    sx={{
                      color: "white",
                      borderRadius: "999px",
                      textTransform: "none",
                    }}
                  >
                    Ubah
                  </Button>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <Button
                    onClick={() => {
                      openModal();
                    }}
                    variant="contained"
                    size="small"
                    sx={{
                      color: "white",
                      borderRadius: "999px",
                      textTransform: "none",
                    }}
                  >
                    Pilih Template
                  </Button>
                </Box>
              )}
            </Grid>
          </Grid>
          <FormHelperText error>{errors.fk_id_template}</FormHelperText>
          <Typography mt={8} mb={2}>
            Template Twibbon Default
          </Typography>

          {selectedTemplateResume ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  selectedTemplateResume.path_thumb_resume_template
                }
                alt={selectedTemplateResume.nama_resume_template}
                style={{ width: "400px" }}
              />
              <Typography>
                {selectedTemplateResume.nama_resume_template}
              </Typography>
              <Button
                onClick={() => {
                  setSelectedTemplate(null);
                }}
                variant="contained"
                size="small"
                sx={{
                  color: "white",
                  borderRadius: "999px",
                  textTransform: "none",
                }}
              >
                Ubah
              </Button>
            </Box>
          ) : (
            <Button
              onClick={() => {
                openModalResume();
              }}
              variant="contained"
              size="small"
              sx={{
                color: "white",
                borderRadius: "999px",
                textTransform: "none",
              }}
            >
              Pilih Twibbon Template
            </Button>
          )}

          <FormHelperText error>{errors.fk_id_resume_template}</FormHelperText>
          <Box sx={{ display: "flex", alignItems: "center", mt: 3 }}>
            <Typography>Tampilkan Twibbon di TV </Typography>
            <Switch
              checked={swResume}
              onChange={handleChangeResume}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Box>
          <Grid mt={6} container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography my={2}>Ucapan Default</Typography>
              {croppedImage ? (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <img width={"80%"} src={croppedImage} alt="uploaded file" />
                </Box>
              ) : (
                <Box sx={{}} />
              )}
              <Box mt={2} {...getRootProps({ style })}>
                <input {...getInputProps()} />
                {isDragAccept && <p>All files will be accepted</p>}
                {isDragReject && <p>Some files will be rejected</p>}
                {isDragActive
                  ? "Drop the files here ..."
                  : "Drag 'n' drop some files here, or click to select files"}
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography my={2}>Ucapan Akhir</Typography>
              {croppedImageEnd ? (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <img
                    width={"80%"}
                    src={croppedImageEnd}
                    alt="uploaded file"
                  />
                </Box>
              ) : (
                <Box sx={{}} />
              )}
              <Box
                sx={{
                  boxSizing: "border-box",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "20px",
                  borderWidth: 2,
                  borderRadius: 2,
                  borderColor: "#eeeeee",
                  borderStyle: "dashed",
                  backgroundColor: "#fafafa",
                  color: "#bdbdbd",
                  outline: "none",
                  transition: "border .24s ease-in-out",
                  width: "100%",
                  mt: 2,
                }}
                {...getRootPropsEnd({ styleend })}
              >
                <input {...getInputPropsEnd()} />
                {isDragAcceptEnd && <p>All files will be accepted</p>}
                {isDragRejectEnd && <p>Some files will be rejected</p>}
                {isDragActiveEnd
                  ? "Drop the files here ..."
                  : "Drag 'n' drop some files here, or click to select files"}
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ display: "flex", alignItems: "center", mt: 3 }}>
            <Typography>Agent</Typography>
            <Switch
              checked={agent}
              onChange={handleChange}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Box>
          {agent ? (
            <Box sx={{ width: "100%" }}>
              <TextField
                fullWidth
                type="number"
                size="small"
                id="saldo"
                name="saldo"
                onChange={handleInputChange}
                label="Saldo Agent"
                variant="outlined"
                sx={{ my: 3 }}
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                error={!!errors.saldo}
                helperText={errors.saldo}
              />
              <FormControl
                fullWidth
                variant="outlined"
                error={!!errors.discount}
              >
                <InputLabel size="small" error={!!errors.discount}>
                  Discount Agent
                </InputLabel>
                <OutlinedInput
                  type="number"
                  size="small"
                  id="discount"
                  name="discount"
                  label="Discount Agent"
                  onChange={handleInputChange}
                  variant="outlined"
                  endAdornment={
                    <InputAdornment position="end">%</InputAdornment>
                  }
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                />
                <FormHelperText error>{errors.discount}</FormHelperText>
              </FormControl>
            </Box>
          ) : (
            <Box />
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              width: "100%",
              mt: 5,
            }}
          >
            <LoadingButton
              endIcon={<LocationCity />}
              // disabled={disabled}
              loading={loadingSts}
              loadingPosition="end"
              onClick={() => {
                handleLoading();
                checkValidate();
              }}
              variant="contained"
              sx={{
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: "400",
                marginRight: "20px",
                color: "white",
                mt: 3,
              }}
            >
              Simpan
            </LoadingButton>
          </Box>
        </Box>
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openCrop}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openCrop}>
          <Box sx={style}>
            {image ? (
              <Box>
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: "100px",
                  }}
                >
                  <Cropper
                    image={image}
                    crop={crop}
                    zoom={zoom}
                    aspect={CROP_AREA_ASPECT}
                    onCropChange={onCropChange}
                    onZoomChange={onZoomChange}
                    onCropComplete={onCropComplete}
                    disableAutomaticStylesInjection={true}
                  />
                </Box>

                <Box
                  sx={{
                    position: "absolute",
                    bottom: "0",
                    left: "50%",
                    width: "100%",
                    transform: "translateX(-50%)",
                    height: "100px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "white",
                  }}
                >
                  <Box
                    sx={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Slider
                      maxWidth="30%"
                      value={zoom}
                      min={1}
                      max={3}
                      step={0.1}
                      aria-labelledby="Zoom"
                      onChange={(e, zoom) => onZoomChange(zoom)}
                    />
                    <Box
                      sx={{
                        ml: 4,
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          showCroppedImage();
                          handleClose();
                        }}
                        sx={{
                          mr: 1,
                          whiteSpace: "nowrap",
                          color: "white",
                          borderRadius: "100px",
                        }}
                      >
                        Crop & Resize
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          handleClose();
                        }}
                        sx={{
                          whiteSpace: "nowrap",
                          color: "white",
                          borderRadius: "100px",
                        }}
                      >
                        Batal
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box />
            )}
          </Box>
        </Fade>
      </Modal>
      <TemplateModal data={dataTemplate} setClose={closeModal} modal={modal} />
      <ResumeTemplateModal
        data={dataTemplateResume}
        setClose={closeModalResume}
        modal={modalResume}
      />
    </Layout>
  );
}

export default FormTambahRD;
